// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Popup } from 'semantic-ui-react';
//stylesheet
import { COLORS } from 'app/config/colors';
import defaultPencil from '../../../../assets/icons/pencil-edit-button.svg';
import DefaultButton from './DefaultButton';

function EditButton(props) {
  const { entity, onClickEdit, pencil, disabled, tag } = props;

  return (
    <Popup
      trigger={
        <DefaultButton
          tag=''
          color={COLORS.ACCENTUATED_VARIANT}
          colorHover={COLORS.WHITE_VARIANT}
          backgroundColor={COLORS.WHITE_VARIANT}
          backgroundColorHover={COLORS.WHITE_VARIANT}
          borderColor={COLORS.SECONDARY_VARIANT}
          borderColorHover={COLORS.SECONDARY_VARIANT}
          onClick={onClickEdit(entity)}
          icon={pencil ? pencil : defaultPencil}
          iconHover={pencil ? pencil : defaultPencil}
          size='medium'
          disabled={disabled}
        />
      }
      content={tag || 'Editar'}
      position='top center'
      positionFixed
      inverted
    />
  );
}

EditButton.defaultProps = {
  tag: 'Editar'
};

EditButton.propTypes = {
  entity: PropTypes.object,
  onClickEdit: PropTypes.func,
  pencil: PropTypes.string,
  disabled: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default EditButton;
